package gr.tech.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("privacy.md", FrontMatterElement.Builder { addScalar("title", "Privacy"); }))
}

@Page("/privacy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This privacy policy has been compiled to better serve those who are concerned with how their ‘Personally Identifiable Information’ (PII) is being used online. PII, as used in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect, or otherwise handle your Personally Identifiable Information in accordance with our website.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("what-information-do-we-collect-from-visitors-to-our-website") }) {
        org.jetbrains.compose.web.dom.Text("What information do we collect from visitors to our website?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may collect ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("name, email address, phone number, and other business details")
        }
        org.jetbrains.compose.web.dom.Text(" when registering for our services via the ‘Contact Form’.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("how-do-we-use-your-information") }) {
        org.jetbrains.compose.web.dom.Text("How do we use your information?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may use your information to:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Process rebate applications and transactions")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Provide customer support and respond to inquiries")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Detect fraud and prevent unauthorized access")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("do not sell")
        }
        org.jetbrains.compose.web.dom.Text(" your information. However, we may share it with utility service providers in order to process transactions. We may also provide required information to legal authorities when required by law or to protect our rights, as well as to partners in cases of mergers, acquisitions, or reorganization.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("cookies-and-tracking-technologies") }) {
        org.jetbrains.compose.web.dom.Text("Cookies and Tracking Technologies")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you leave a comment or contact us via our site you may opt-in to saving your name, email address, and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave interact again.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("how-long-do-we-retain-your-data") }) {
        org.jetbrains.compose.web.dom.Text("How long do we retain your data?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you leave a comment or fill out a form, the content of both messages will be retained ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("indefinitely")
        }
        org.jetbrains.compose.web.dom.Text(". This is so we can approve any follow-up communications automatically instead of holding them in a moderation queue.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("third-party-links") }) {
        org.jetbrains.compose.web.dom.Text("Third-Party Links")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our website may contain links to third-party websites. We are not responsible for their privacy practices and encourage you to review their policies before providing any personal data.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("data-security") }) {
        org.jetbrains.compose.web.dom.Text("Data Security")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We implement industry-standard security measures to protect your data from unauthorized access, disclosure, or loss. In compliance with Fair Information Practices, in case of a data breach we will notify those affected within ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("7 business days")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("what-rights-do-you-have-over-your-data") }) {
        org.jetbrains.compose.web.dom.Text("What rights do you have over your data?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you have made comments on this site or filled out a form, you may request an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security reasons.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("sms-messaging") }) {
        org.jetbrains.compose.web.dom.Text("SMS Messaging")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By clicking “Submit” on our ‘Contact Form’ you are hereby consenting to receive messages sent by Green Rebates. Personal information may be collected; however, it will ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("never")
        }
        org.jetbrains.compose.web.dom.Text(" be shared with third parties for marketing purposes. Message frequency varies. Message and data rates may apply.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Reply ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("HELP")
            }
            org.jetbrains.compose.web.dom.Text(" for assistance")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Reply ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("STOP")
            }
            org.jetbrains.compose.web.dom.Text(" to opt-out of messaging")
        }
    }
}
